import Err from 'utils/src/error';

function notImplemented() {
	throw new Err('IFactory is an abstract class and should not be instantiated directly.');
}

export default class IFactory {

}